export default {
  mounted () {
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry.isIntersecting) {
          this.pushEvent('load_more_chats', {})
        }
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 0.1
      }
    )

    this.observer.observe(this.el)
  },

  destroyed () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
